:host {
  background-color: var(--white-layout-301-level-0-elevation);
}

.wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;

  &.is-loading {
    .sub-wrapper {
      display: none;
    }

    gz-progress-spinner {
      display: block;
    }
  }

  gz-button[id='learn-more'] {
    &::part(button) {
      color: var(--body-text-arrows-400);
    }
  }

  gz-banner {
    display: flex;
    padding-top: 30px;
    padding-left: 36px;
    &::part(logo) {
      display: none;
    }
  }

  .customer-wrapper {
    max-width: 950px;
  }

  .sub-wrapper {
    padding: 0;
  }

  gz-progress-spinner {
    display: none;
  }
}

#create-text {
  text-align: left;
  width: 600px;
  margin-bottom: 24px;
}

gz-icon[id='iz-icon'] {
  justify-content: flex-start;
  display: flex;
  padding-bottom: var(--spacer);
  svg {
    height: 80px;
    fill: var(--black-layout-700-primary);
  }
}
